import React, { useState, useEffect, useRouter } from 'react';
import PropTypes from 'prop-types';
import Social from './Social';
import { SOCIALS_MAP } from '../../consts';

const Socials = ({
  parent,
  order = ['tiktok', 'pinterest', 'facebook', 'instagram', 'youtube'],
  prependedChildren,
  appendedChildren,
  key,
  logoClick,
  verticalHomepage = false,
}) => {

  const [isCollapsed, setIsCollapsed] = useState(true);

  // const router = useRouter();
  // const { id } = router.query;

  useEffect(() => {
    setIsCollapsed(true);
  }, [logoClick || key]);

  if (parent === 'Footer') {
    order = ['tiktok','instagram', 'pinterest', 'facebook', 'youtube']
  }
  if (parent === 'Nav') {
    order = ['tiktok', 'instagram',  'pinterest', 'facebook', 'youtube']
  }
  if (verticalHomepage) {
    order = ['tiktok', 'instagram',  'pinterest', 'facebook', 'youtube']
  }

  const renderedSocials = order.map(id => SOCIALS_MAP[id]).map((social, i) => {
    const { className, href, icon } = social;

    const link = href;

    return (
      <Social
        key={i}
        className={className}
        href={link}
        parent={parent} 
        icon={icon}/>
    );
  });


  return (
    <div className='socials vertical-homepage'>
      {prependedChildren}
      {renderedSocials}
      {appendedChildren}
    </div>
  );
};

Socials.propTypes = {
  parent: PropTypes.string,
  order: PropTypes.array,
  prependedChildren: PropTypes.node,
  appendedChildren: PropTypes.node,
};

export default Socials;
